export enum SortCruiseByEnum {
    PRICE_LOW_TO_HIGH = 1,
    PRICE_HIGH_TO_LOW= 2,
    CATEGORY_ASC = 3,
    CATEGORY_DESC = 4
  }
  